
import React, { Component } from 'react';

import "./style/HyperList.css";


const HyperList = function (props) {

    return (
        <div className={"hyperlist " + (props.className ? props.className : "")} style={props.style}>
            <div className="hyperlist-header">
                <h2 className="hyperlist-title h4">
                    {props.listTitle}
                </h2>
            </div>
            <ul aria-label={props.listTitle} className="hyperlist-items">
                {props.hyperListBody}
            </ul>
        </div>
    )
}

export default HyperList;